import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { FundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveFundingRequest = createAsyncThunk<FundingRequestVM, string, { extra: Partial<Dependencies> }>(
  "fundingRequests/retrieveFundingRequest",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.get(id);
  },
);

export const resetRetrieveFundingRequest = createAction("fundingRequests/resetRetrieveFundingRequest");
